













import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItemModelUtil } from '../model-utils/item-model-util';
import { PlaceItem } from '../models/items/place-item-model';
import { GOOGLE_MAPS_API_KEY } from '@/secrets';

@Component({})
export default class DynamicItemMap extends Vue {
  @Prop(PlaceItem) public item!: PlaceItem;
  @Prop(Number) size: number;
}
